export default function Footer() {
   return (
      <footer className="flex flex-ai-c flex-jc-c flex-column">
         <span>
            Fiszkoteka, Projekt graficzny strony zaczerpnięty z challengu Fronted Mentor.<br />
            <i className="icon-mail-1" >maciekgoncerzewicz@gmail.com</i>
         </span>
      </footer>
   );
}